<template>
  <div class="oreder-modal">
    <el-dialog
      :close-on-click-modal="false"
      title="Edit"
      :visible="visible"
      width="580px"
      :before-close="handleClose"
    >
      <div class="oreder-modal-wrap">
        <el-form :model="form" label-position="top">
          <el-form-item label="Credit Card Number">
            <el-input type="text"  v-model="form.number"></el-input>
          </el-form-item>

          <el-form-item>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="Expiration Date">
                  <el-date-picker
                    style="width: 100%"
                    type="daterange"
                    v-model="form.date"
                    placeholder=""
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Security Code">
                  <el-input type="text" v-model="form.code"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <p class="tips">
              The address affiliated with this credit card must match the
              contact information active on this account.
            </p>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">Cancel</el-button>
        <el-button type="primary" @click="visible = false">Save</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      form: {
        date: "",
        number:'',
        code:''
      },
    };
  },
  watch: {
    visible: {
      handler(n, o) {
        this.visible = n;
      },
    },
  },
  props: {},
  methods: {
    handleClose() {
      this.visible = false;
    },
    showChange() {
      this.visible = !this.visible;
    },
  },
};
</script>

<style scoped lang="scss">

.tips {
  font-size: 12px;
  color: #5e6d81;
  line-height: 22px;
  word-wrap: break-word;
  word-break: break-all;
}
</style>
<style>
.oreder-modal-wrap .el-form-item__label {
  color: #5e6d81;
  font-size: 14px;
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/user/EditPay.vue